import { render } from "./BalanceHistory.vue?vue&type=template&id=0db784c4&scoped=true"
import script from "./BalanceHistory.vue?vue&type=script&lang=js"
export * from "./BalanceHistory.vue?vue&type=script&lang=js"

import "./BalanceHistory.vue?vue&type=style&index=0&id=0db784c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db784c4"]])

export default __exports__